export const paymentInitRoute = {
  path: '/payment/init',
  component: 'payment-init',
  componentName: 'Payment Init',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentEnterMobileRoute = {
  path: '/payment/enter-mobile',
  component: 'payment-enter-mobile',
  componentName: 'Enter Mobile',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentLenderListRoute = {
  path: '/payment/lender-list',
  component: 'payment-lender-list',
  componentName: 'Payment Lender List',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentEmiSelectionRoute = {
  path: '/payment/emi-selection',
  component: 'payment-emi-selection',
  componentName: 'Payment EMI Selection',
  theme: 'instaCred',
  template: 'payment',
};

export const payLaterPlanSelectionRoute = {
  path: '/payment/paylater-plan-selection',
  component: 'paylater-plan-selection',
  componentName: 'PayLater Plan Selection',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentConfirmRoute = {
  path: '/payment/confirm',
  component: 'payment-confirm',
  componentName: 'Payment Confirm',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentSuccessRoute = {
  path: '/payment/success',
  component: 'payment-success',
  componentName: 'Payment Success',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentFailureRoute = {
  path: '/payment/failure',
  component: 'payment-failure',
  componentName: 'Payment Failure',
  theme: 'instaCred',
  template: 'payment',
};

export const posCustomerPaymentSuccessRoute = {
  path: '/payment/customer-device-success',
  component: 'pos-customer-payment-success',
  componentName: 'Payment Success',
  theme: 'instaCred',
  template: 'payment',
};

export const posCustomerPaymentFailureRoute = {
  path: '/payment/customer-device-failure',
  component: 'pos-customer-payment-failure',
  componentName: 'Payment Failure',
  theme: 'instaCred',
  template: 'payment',
};

export const voucherTncRoute = {
  path: '/voucher-tnc/:lenderName',
  component: 'voucher-tnc',
  componentName: 'Voucher Terms and Conditions',
  theme: 'instaCred',
  template: 'payment',
};

export const eMandateRedirect = {
  path: '/e-mandate-redirect/:requestId',
  component: 'e-mandate-redirect',
  componentName: 'E-Mandate Redirect',
  theme: 'instaCred',
  template: 'payment',
};

export const eMandateResult = {
  path: '/e-mandate-result',
  component: 'e-mandate-result',
  componentName: 'E-Mandate Result',
  theme: 'instaCred',
  template: 'payment',
};

export const posSmsRoute = {
  path: '/pos-sms',
  component: 'pos-sms',
  componentName: 'Pos Sms',
  theme: 'instaCred',
  template: 'payment',
};

export const posPaymentInitRoute = {
  path: '/payment/pos-init',
  component: 'pos-payment-init',
  componentName: 'Pos Payment Init',
  theme: 'instaCred',
  template: 'payment',
};

export const edcPosPaymentInitRoute = {
  path: '/payment/edc-pos-init',
  component: 'edc-pos-payment-init',
  componentName: 'EDC Pos Payment Init',
  theme: 'instaCred',
  template: 'payment',
};

export const displayKfsDataRoute = {
  path: '/payment/kfs',
  component: 'kfs-container',
  componentName: 'Kfs Container',
  theme: 'instaCred',
  template: 'payment',
};

export const paymentNtbRoute = {
  path: '/payment/ntb',
  component: 'in-txn-ntb',
  componentName: 'In Transaction Ntb',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentNtbFailureRoute = {
  path: '/payment/ntb-failure',
  component: 'ntb-payment-failure',
  componentName: 'Ntb Payment Status',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentNtbBenefitsRoute = {
  path: '/payment/ntb-benefits',
  component: 'ntb-single-lender-benefits-screen',
  componentName: 'NTB Benefits Screen',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentNtbPreEligibilityRoute = {
  path: '/payment/pre-eligibility',
  component: 'ntb-single-lender-pre-eligibility',
  componentName: 'NTB Pre Eligibility Screen',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentNtbPreEligibilityFailureRoute = {
  path: '/payment/pre-eligibility/failure',
  component: 'ntb-single-lender-pre-eligibility-failure',
  componentName: 'NTB Pre Eligibility Failure Screen',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentNtbLenderAndTenureSelectionRoute = {
  path: '/payment/lender-emi-select',
  component: 'ntb-single-lender-tenure-select',
  componentName: 'NTB Lender and Tenure Selection Screen',
  theme: 'instaCred',
  template: 'ntbPayment',
};

export const paymentRoutes = [
  paymentInitRoute,
  paymentEnterMobileRoute,
  paymentLenderListRoute,
  paymentEmiSelectionRoute,
  payLaterPlanSelectionRoute,
  paymentConfirmRoute,
  paymentSuccessRoute,
  paymentFailureRoute,
  posCustomerPaymentSuccessRoute,
  posCustomerPaymentFailureRoute,
  voucherTncRoute,
  eMandateRedirect,
  eMandateResult,
  posSmsRoute,
  posPaymentInitRoute,
  edcPosPaymentInitRoute,
  displayKfsDataRoute,
  paymentNtbRoute,
  paymentNtbFailureRoute,
  paymentNtbBenefitsRoute,
  paymentNtbPreEligibilityRoute,
  paymentNtbPreEligibilityFailureRoute,
  paymentNtbLenderAndTenureSelectionRoute,
];



// WEBPACK FOOTER //
// ./alias/paymentRoutes.js